import * as React from 'react'

import { Textarea } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { ContentEditorProps } from 'modules/trainings/components/content/types'
import { QuizBlock } from 'modules/trainings/lib/content/QuizBlock'

const QuizBlockEditor = observer(({ contentItem: quiz }: ContentEditorProps<QuizBlock>) => {
  const ensureFormExists = () => {
    if (!quiz.form) {
      quiz.form = {
        id: null,
        title: quiz.title,
        description: undefined,
        resourceId: null,
        resourceType: 'Trainings::Training',
        formType: 'quiz',
        elements: [],
      }
    }
  }

  return (
    <>
      <Textarea
        label={i18n.t('trainings.content.block.quiz.title_label')}
        onChange={(value: string) => {
          ensureFormExists()
          quiz.title = value
          if (quiz.form) {
            quiz.form.title = value
          }
        }}
        placeholder={i18n.t('trainings.content.block.quiz.title_placeholder')}
        value={quiz.title}
      />
      <Textarea
        label={i18n.t('trainings.content.block.quiz.description_label')}
        onChange={(value: string) => {
          ensureFormExists()
          if (quiz.form) {
            quiz.form.description = value
          }
        }}
        placeholder={i18n.t('trainings.content.block.quiz.description_placeholder')}
        value={quiz.form?.description ?? undefined}
      />
    </>
  )
})

export { QuizBlockEditor }
